import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

interface GraphFiltersState {
  nodeTypes: string[]
  layer: 'all' | 'deterministic' | 'process-semantic'
  area: string
}

export interface GraphState {
  selectedNodeId: string | null
  highlightedNodeIds: string[]
  filters: GraphFiltersState
}

const initialState: GraphState = {
  selectedNodeId: null,
  highlightedNodeIds: [],
  filters: {
    nodeTypes: [],
    layer: 'all',
    area: ''
  }
}

const graphSlice = createSlice({
  name: 'graph',
  initialState,
  reducers: {
    setSelectedNodeId(state, action: PayloadAction<string | null>) {
      state.selectedNodeId = action.payload
    },
    setHighlightedNodeIds(state, action: PayloadAction<string[]>) {
      state.highlightedNodeIds = action.payload
    },
    setGraphFilters(state, action: PayloadAction<Partial<GraphFiltersState>>) {
      state.filters = {
        ...state.filters,
        ...action.payload
      }
    },
    clearGraphFilters(state) {
      state.filters = initialState.filters
    }
  }
})

export const { clearGraphFilters, setGraphFilters, setHighlightedNodeIds, setSelectedNodeId } =
  graphSlice.actions

export default graphSlice.reducer
